module.exports = __webpack_public_path__ + "img/HeikeBirkner_140x140_rund.c22d3d4c.jpg";